import { Flex, Paper, Text } from '@mantine/core';
import type { DetailsSummaryBoxProps, Props } from './DetailsSummaryBox.types';

export const DetailsSummaryBox = ({
	items,
	direction = 'row',
	radius = 'md',
}: DetailsSummaryBoxProps) => {
	return (
		<Paper
			radius={radius}
			p="1rem"
			w="100%"
			sx={(theme) => ({
				border: `1px solid ${theme.colors.gray[4]}`,
			})}
		>
			<Flex direction={direction} justify="space-between" gap="1rem">
				{items?.map((item, index) => (
					<DetailsSummaryBoxItem key={`summary-item-${index}`} {...item} />
				))}
			</Flex>
		</Paper>
	);
};
const DetailsSummaryBoxItem = ({ title, value, children }: Props) => {
	return (
		<Flex direction="column" gap="0.25rem">
			<Text fz="md" truncate c="dark.0">
				{title}
			</Text>
			{!!value && (
				<Text fz="lg" c="dark.8" lineClamp={2} truncate>
					{value}
				</Text>
			)}
			{children}
		</Flex>
	);
};
